// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"ad49ff15","285":"f811c988","631":"bccecff4","760":"3158ad1c","774":"c40a5cdc","787":"211d69aa","819":"92dd9486","851":"a58dd3b2"}[chunkId] + ".chunk.js";
};